module.exports = "/_next/static/images/cableDesign3-9f2b9cfa0b37a594bf053c4c41b4bc8c.webp";